import ts from 'typescript';
import { NodeCompiler } from '../NodeCompiler';
export class YieldExpressionCompiler extends NodeCompiler {
    constructor() {
        super(...arguments);
        this.kind = ts.SyntaxKind.YieldExpression;
    }
    visitNode(sb, expr, _options) {
        sb.context.reportUnsupported(expr);
    }
}

//# sourceMappingURL=YieldExpressionCompiler.js.map
